module.exports = __webpack_public_path__ + "img/ebay.c09c1319.svg";